import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Radio reset controller connected")
  }
  clear(event) {
    event.preventDefault()
    event.stopPropagation()

    const inputs = this.element.querySelectorAll('input[type="radio"], input[type="checkbox"]')
    const name = inputs[0]?.name

    if (name) {
      document.querySelectorAll(`input[name="${name}"]`).forEach(input => input.checked = false)
    }
  }
}
